import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Paper,
  Button,
  Container,
  useMediaQuery,
  Drawer,
  AppBar,
  Toolbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

import TouchAppIcon from "@mui/icons-material/TouchApp";
import FeedbackDialog from "./FeedbackDialog";

import * as MuiIcons from "@mui/icons-material";
import CustomInputSwitch from "./CustomInputSwitch";
import SchoolIcon from "@mui/icons-material/School";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { InstructionItem } from "./functions";
import FunctionsSwitcher from "./FunctionsSwitcher";
import { useTheme } from "@mui/material/styles";
import { getStyles } from "../index";
import {
  lessonItems,
  quizItems,
  flashcardItems,
  textLabbetItems,
  gradingItems,
  powerpointItems,
  assistentItems,
  visionItems,
  imageItems,
  VideoPlayer,
  lessonPlanItems,
  podcastItems,
  hpItems,
} from "./HelpDialogItems";

import {
  podcastItemsStudent,
  quizItemsStudent,
  flashcardItemsStudent,
  assistentItemsStudent,
  gradingItemsStudent,
  imageItemsStudent,
  hpItemsStudent,
} from "./HelpDialogItemsStudents";

const HelpDialog = ({
  open,
  onClose,
  quiz = false,
  flashcards = false,
  textLabbet = false,
  grading = false,
  powerpoint = false,
  assistent = false,
  overview = false,
  vision = false,
  lessonPlan = false,
  podcast = false,
  insideApp = true,
  hp = false,
  lessonType,
  user,
  accountType,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [currentTab, setCurrentTab] = useState(0);
  const [selectedFunction, setSelectedFunction] = useState(null);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  // const role =
  //   accountType !== undefined ? accountType : user?.accountType || "teacher";
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [role, setRole] = useState(
    accountType !== undefined ? accountType : user?.accountType || "teacher",
  );

  const [selectedUserType, setSelectedUserType] = useState(
    role === "teacher" ? 0 : 1,
  );

  const isTeacher = role !== "student";
  // Define sections with their icons, colors, and corresponding items
  const sections = [
    {
      id: 0,
      title: "Lektion",
      icon: "Create",
      color: "#3B82F6",
      path: "/app/lektioner",
      teacherItems: lessonItems,
      studentItems: [],
      showForTeacher: true,
      showForStudent: false,
    },
    {
      id: 1,
      title: "Quiz",
      icon: "Psychology",
      color: "#9333EA",
      path: "/app/quiz",
      teacherItems: quizItems,
      studentItems: quizItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 2,
      title: "Flashcards",
      icon: "ViewAgenda",
      color: "#22C55E",
      path: "/app/flashcards",
      teacherItems: flashcardItems,
      studentItems: flashcardItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 3,
      title: "Podcast",
      icon: "Mic",
      color: "#5760c4",
      path: "/app/podcast",
      teacherItems: podcastItems,
      studentItems: podcastItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 4,
      title: "Bedömning",
      icon: "Assignment",
      color: "#b45309",
      path: "/app/uppsats/ny",
      teacherItems: gradingItems,
      studentItems: gradingItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 5,
      title: "Lektionsplan",
      icon: "EventNote",
      color: "#0f172a",
      path: "/app/lektioner/lektionsplan",
      teacherItems: lessonPlanItems,
      studentItems: [],
      showForTeacher: true,
      showForStudent: false,
    },
    {
      id: 6,
      title: "Assistent",
      icon: "SmartToy",
      color: "#EF4444",
      path: "/app/larare",
      teacherItems: assistentItems,
      studentItems: assistentItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 7,
      title: "Bilder",
      icon: "AddPhotoAlternate",
      color: "#6366f1",
      path: "/app/bilder",
      teacherItems: imageItems,
      studentItems: imageItemsStudent,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 8,
      title: "Prov",
      icon: "HistoryEdu",
      color: "#a5292a",
      path: "/app/hp",
      teacherItems: hpItems,
      studentItems: hpItemsStudent,
      showForTeacher: true,
      showForStudent: false,
    },
    {
      id: 9,
      title: "Högskoleprov",
      icon: "HistoryEdu",

      color: "#a5292a",
      path: "/app/hogskoleprov",
      teacherItems: hpItems,
      studentItems: hpItemsStudent,
      showForTeacher: false,
      showForStudent: true,
    },
    {
      id: 10,
      title: "Textlabbet",
      icon: "Notes",
      color: "#059669",
      path: "/app/textlabbet",
      teacherItems: textLabbetItems,
      studentItems: textLabbetItems,
      showForTeacher: true,
      showForStudent: true,
    },
    {
      id: 11,
      title: "PowerPoint",
      icon: "Slideshow",
      color: "#ea580c",
      path: "/app/powerpoint",
      teacherItems: powerpointItems,
      studentItems: [],
      showForTeacher: true,
      showForStudent: false,
    },
  ];

  // Filter sections based on role
  const filteredSections = sections.filter(
    (section) =>
      (role === "teacher" && section.showForTeacher) ||
      (role === "student" && section.showForStudent),
  );

  // Determine which section should be initially selected based on props
  const getInitialSelectedTab = () => {
    if (quiz) return filteredSections.findIndex((s) => s.title === "Quiz") + 1;
    if (flashcards)
      return filteredSections.findIndex((s) => s.title === "Flashcards") + 1;
    if (textLabbet)
      return filteredSections.findIndex((s) => s.title === "Textlabbet") + 1;
    if (powerpoint)
      return filteredSections.findIndex((s) => s.title === "PowerPoint") + 1;
    if (grading)
      return filteredSections.findIndex((s) => s.title === "Bedömning") + 1;
    if (assistent)
      return filteredSections.findIndex((s) => s.title === "Assistent") + 1;
    if (vision)
      return filteredSections.findIndex((s) => s.title === "Bilder") + 1;
    if (lessonPlan)
      return filteredSections.findIndex((s) => s.title === "Lektionsplan") + 1;
    if (podcast)
      return filteredSections.findIndex((s) => s.title === "Podcast") + 1;
    if (lessonType)
      return filteredSections.findIndex((s) => s.title === "Lektion") + 1;
    if (hp)
      return (
        filteredSections.findIndex((s) => s.title === "Prov") + 1 ||
        filteredSections.findIndex((s) => s.title === "Högskoleprov") + 1
      );

    return 0; // Default to home view
  };

  // No need for role switching since accountType is already known

  // Set initial selected tab based on props
  useEffect(() => {
    if (currentTab === 0) {
      setCurrentTab(getInitialSelectedTab());
    }
  }, [open]);

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
    setSelectedFunction(null);
  };

  const handleUserTypeChange = (index) => {
    setSelectedUserType(index);
    const newRole = index === 0 ? "teacher" : "student";
    setRole(newRole);

    // Reset to default tab when changing roles to avoid errors
    setCurrentTab(0);
  };

  const handleNavigate = (path) => {
    onClose();
    // Assuming you have navigation available in props or context
    navigate(path);
  };

  const renderFunctionContent = () => {
    if (currentTab === 0) {
      return (
        <Box sx={{ p: 0, maxWidth: "1300px", margin: "0 auto" }}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 4,
            }}
          >
            <Box sx={{ textAlign: "center", py: 6 }}>
              <TouchAppIcon
                sx={{
                  fontSize: 80,
                  color: theme.palette.text.secondary,
                  opacity: 0.6,
                  mb: 3,
                }}
              />

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 400,
                  mb: 3,
                  color: theme.palette.text.secondary,
                }}
              >
                Klicka på valfri sektion ovan för att lära dig mer
              </Typography>
            </Box>
          </Paper>
        </Box>
      );
    }

    const selectedSection = filteredSections[currentTab - 1];

    if (!selectedSection) {
      return (
        <Box sx={{ textAlign: "center", py: 10 }}>
          <Typography variant="h5" sx={{ mb: 2, color: "text.secondary" }}>
            Ingen kategori vald
          </Typography>
          <Typography>Välj en kategori från menyn ovan.</Typography>
        </Box>
      );
    }

    const items =
      role === "teacher"
        ? selectedSection.teacherItems || []
        : selectedSection.studentItems || [];

    return (
      <>
        <Box sx={{ maxWidth: "1300px", margin: "0 auto" }}>
          <Box
            sx={{
              //display: "flex",
              display: "none",
              alignItems: "center",
              mb: 4,
              borderBottom: `1px solid ${theme.palette.divider}`,
              p: 4,
            }}
          >
            <Typography
              variant="h3"
              sx={{ fontWeight: 600, fontSize: "1.5rem" }}
            >
              {selectedSection.title}
            </Typography>
          </Box>

          {items.length > 0 ? (
            items.map((highlight, index) => (
              <Box
                key={index}
                sx={{
                  mt: 3,
                  mb: 8,
                  p: { xs: 2, sm: 4 },
                  borderRadius: 4,

                  boxShadow: "none",
                  animation: "fadeIn 0.4s ease forwards",
                  backgroundImage: "none",
                  "&:hover": {
                    transition: "all 0.3s ease",
                  },
                  "@keyframes fadeIn": {
                    "0%": {
                      opacity: 0,
                      transform: "translateY(10px)",
                    },
                    "100%": {
                      opacity: 1,
                      transform: "translateY(0)",
                    },
                  },
                }}
              >
                <Grid
                  container
                  spacing={6}
                  alignItems="center"
                  direction={index % 2 === 0 ? "row-reverse" : "row"}
                >
                  {/* Video */}
                  <Grid item xs={12} md={6}>
                    <VideoPlayer
                      videoUrl={highlight.videoUrl}
                      poster={highlight.poster}
                      animationType="pulse"
                      autoplayOnScroll={false}
                    />
                  </Grid>

                  {/* Features list */}
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: 700,
                          mb: highlight.description ? 2 : 4,

                          fontSize: { xs: "2rem", md: "2.5rem" },
                        }}
                      >
                        {highlight.title}
                      </Typography>

                      {highlight.description && (
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "text.secondary",
                            fontSize: { xs: "1rem", md: "1.1rem" },
                            lineHeight: 1.7,
                            whiteSpace: "pre-line",
                            mb: 4,
                          }}
                        >
                          {highlight.description}
                        </Typography>
                      )}

                      {highlight.listItems &&
                        highlight.listItems.length > 0 && (
                          <Box sx={{ mb: 3 }}>
                            {highlight.listItems.map((item, i) => (
                              <InstructionItem
                                key={i}
                                text={item.text}
                                marginBottom={1.5}
                                simple="true"
                                fontWeight="400"
                                color="text.secondary"
                              />
                            ))}
                          </Box>
                        )}

                      {highlight.useCases && highlight.useCases.length > 0 && (
                        <Box
                          sx={{
                            p: 2,
                            mt: "auto",
                            bgcolor: `${selectedSection.color}15`,
                            borderRadius: 2,
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{ mb: 1, fontWeight: 600 }}
                          >
                            Användningsområden:
                          </Typography>
                          <Typography variant="body2">
                            {highlight.useCases.join(", ")}
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                {highlight.path && (
                  <Box
                    sx={{
                      mt: 5,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      variant="purp"
                      endIcon={<ArrowForwardIcon />}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNavigate(highlight.path || selectedSection.path);
                      }}
                    >
                      Prova nu
                    </Button>
                  </Box>
                )}
              </Box>
            ))
          ) : (
            <Box sx={{ textAlign: "center", py: 10 }}>
              <Typography variant="h5" sx={{ mb: 2, color: "text.secondary" }}>
                Inga resultat hittades
              </Typography>
              <Typography>
                Inga funktioner tillgängliga för denna kategori.
              </Typography>
            </Box>
          )}
          {selectedSection.title === "Lektion" && (
            <>
              <Container
                maxWidth="lg"
                sx={{ mb: 15, maxWidth: "1300px !important" }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    fontSize: { xs: "2rem", md: "2.8rem" },
                  }}
                >
                  Smidig kontrollpanel
                </Typography>
                <Typography
                  variant="subtitle"
                  sx={{
                    mb: 4,
                    color: "text.secondary",
                    fontSize: { xs: "1rem", md: "1.3rem" },
                    lineHeight: 1.7,
                    whiteSpace: "pre-line",
                  }}
                >
                  Hantera din lektion från en smidig kontrollpanel
                </Typography>
                <Box sx={{ mt: 4 }}>
                  <VideoPlayer
                    videoUrl="https://sportkuriren.se/wp-content/uploads/control-panel4.mp4"
                    autoPlay={true}
                  />
                </Box>
              </Container>
            </>
          )}

          {selectedSection.title === "Quiz" && (
            <>
              <Container
                maxWidth="lg"
                sx={{ mb: 15, maxWidth: "1300px !important" }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    fontSize: { xs: "2rem", md: "2.8rem" },
                  }}
                >
                  Flera frågetyper
                </Typography>
                <Typography
                  variant="subtitle"
                  sx={{
                    mb: 4,
                    color: "text.secondary",
                    fontSize: { xs: "1rem", md: "1.3rem" },
                    lineHeight: 1.7,
                    whiteSpace: "pre-line",
                  }}
                >
                  Välj mellan skriftliga prov, flervalsfrågor m.m.
                </Typography>
                <Box sx={{ mt: 4 }}>
                  <VideoPlayer
                    videoUrl="https://sportkuriren.se/wp-content/uploads/quiz-fragetyper.mp4"
                    autoPlay={true}
                  />
                </Box>
              </Container>
              <Container
                maxWidth="lg"
                sx={{ mb: 15, maxWidth: "1300px !important" }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    mb: 2,
                    fontSize: { xs: "2rem", md: "2.8rem" },
                  }}
                >
                  Exempel på frågetyper
                </Typography>
                <Box sx={{ mb: 4 }}>
                  <Typography
                    variant="subtitle"
                    sx={{
                      color: "text.secondary",
                      fontSize: { xs: "1rem", md: "1.3rem" },
                      lineHeight: 1.7,
                      whiteSpace: "pre-line",
                    }}
                  >
                    Du kan välja mellan olika frågeformat som skriftliga prov,
                    flervalsfrågor, lucktext, sant/falskt och nutidsfrågor.
                    Dessa kan användas för att testa olika kunskapsområden,
                    anpassa svårighetsgraden och skapa variation i dina quiz.
                  </Typography>
                </Box>
                <FunctionsSwitcher
                  functions={[
                    {
                      title: "Flervalsfrågor",
                      subtitle:
                        "Flervalsfrågor med ett korrekt svar där du väljer det alternativ som bäst besvarar frågan.",
                      videoUrl:
                        "https://sportkuriren.se/wp-content/uploads/quiz-flervalsfragor-2.mp4",
                      poster:
                        "https://sportkuriren.se/wp-content/uploads/quiz-flervalsfragor.png",
                    },
                    {
                      title: "Skriftligt prov",
                      subtitle:
                        "Simulera ett riktigt prov där du får visa dina kunskaper genom att formulera egna, utförliga svar.",
                      videoUrl:
                        "https://sportkuriren.se/wp-content/uploads/quiz-prov-2.mp4",
                      poster:
                        "https://sportkuriren.se/wp-content/uploads/quiz-prov.png",
                    },
                    {
                      title: "Lucktext",
                      subtitle:
                        "Välj rätt utelämnat ord i frågan för att visa att du förstår kontexten.",
                      videoUrl:
                        "https://sportkuriren.se/wp-content/uploads/quiz-fyll-i-luckan-2.mp4",
                      poster:
                        "https://sportkuriren.se/wp-content/uploads/quiz-fyll-i-luckan.png",
                    },
                    {
                      title: "Sant/Falskt",
                      subtitle:
                        "Påståenden som är sanna eller falska och kräver att du bedömer informationens korrekthet.",
                      videoUrl:
                        "https://sportkuriren.se/wp-content/uploads/quiz-sant-falskt-2.mp4",
                      poster:
                        "https://sportkuriren.se/wp-content/uploads/quiz-sant-falskt.png",
                    },
                    {
                      title: "Nutidsfrågor",
                      subtitle:
                        "Traditionella nutidsfrågor i 1X2-format med svarstalong och facit.",
                      videoUrl:
                        "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-3.mp4",
                      poster:
                        "https://sportkuriren.se/wp-content/uploads/quiz-nutidsfragor-3.png",
                    },
                  ]}
                />
              </Container>
            </>
          )}
        </Box>

        <Box sx={{ textAlign: "center", mt: 10, color: "text.secondary" }}>
          Har du några frågor?{" "}
          <Box
            component="span"
            sx={{
              color: "primary.main",
              cursor: "pointer",
              fontWeight: 500,
              textDecoration: "none",
              display: "inline",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
            onClick={() => setContactDialogOpen(true)}
          >
            Kontakta oss
          </Box>
        </Box>
      </>
    );
  };

  return (
    <>
      <Drawer
        anchor="bottom" // Change from "right" to "bottom"
        open={open}
        onClose={onClose}
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100vw",
            height: "93%", // You might want to adjust this height
            borderRadius: "16px 16px 0 0", // Rounded corners at the top
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", left: 12, top: 12, zIndex: 999999 }}
        >
          <ArrowBackIcon sx={{ fontSize: 30 }} />
        </IconButton>

        <Box sx={styles.container}>
          <Box
            sx={{
              ...styles.innerContainer,
              width: { xs: "100%", md: "100%" },
              margin: "0 auto",
              p: 3,
              pt: 1,
            }}
          >
            {selectedFunction === null && (
              <>
                <Box sx={{ mb: 6, textAlign: "center" }}>
                  <Typography
                    variant="h1"
                    sx={{
                      ...styles.newH1,
                      marginTop: "0px",
                      marginBottom: "0px",
                      paddingBottom: "0px",
                      fontSize: { xs: "1.5rem", md: "1.8rem" },
                    }}
                  >
                    {currentTab === 0
                      ? "Hjälpguide"
                      : `Hjälpguide (${filteredSections[currentTab - 1]?.title || "Utforska Studera.ai"})`}
                  </Typography>

                  <Box
                    sx={{
                      position: "absolute",
                      top: isMobile ? 75 : 15, // Higher position on mobile
                      right: isMobile ? "50%" : 15, // Center on mobile
                      transform: isMobile ? "translateX(50%)" : "none", // Center on mobile
                      zIndex: isMobile ? 20 : 10,
                      width: isMobile ? "100%" : "auto",
                      //display: "flex",
                      display: "none",
                      justifyContent: "center",
                    }}
                  >
                    <CustomInputSwitch
                      selectedIndex={selectedUserType}
                      onIndexChange={handleUserTypeChange}
                      options={["Lärare", "Elever"]}
                      optionIcons={[<SchoolIcon />, <PersonOutlineIcon />]}
                      theme={theme}
                      width="250px"
                      mobileWidth="320px"
                      height="42px"
                      iconSpacing="10px"
                      borderRadius="16px"
                      iconSize="1.3rem"
                      activeColor={
                        theme.palette.themeType === "allakando"
                          ? "#96c933"
                          : "#909090"
                      }
                      nonActiveColor={
                        theme.palette.mode === "dark" ? "#3a454f" : "#ececec"
                      }
                      fontSize={
                        theme.palette.themeType === "allakando"
                          ? "1rem"
                          : "0.9rem"
                      }
                      fontWeight="500"
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    p: 0.5,
                    borderRadius: 4,
                    backgroundColor:
                      theme.palette.mode === "dark" ? undefined : "#fff",
                    backgroundImage: "none",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",

                    margin: "0 auto", // Center the box
                    mb: 9,
                    mt: isMobile ? 12 : 2,
                    maxWidth: "1310px", // Set a max width but DON'T restrict the content
                    width: "100%", // Ensure it takes available width
                    overflowY: "hidden",
                  }}
                >
                  {/* Navigation tabs - with preserved scrolling behavior */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: { xs: "nowrap", md: "nowrap" }, // IMPORTANT: changed to nowrap on both sizes
                      overflowX: { xs: "auto", md: "auto" }, // IMPORTANT: changed to auto on both sizes
                      gap: 0,
                      overflowY: "hidden",
                      pb: { xs: 2, md: 0 },

                      justifyContent: "flex-start",
                      alignItems: "center", // Centers content vertically
                      "&::-webkit-scrollbar": {
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "rgba(0,0,0,0.1)",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    {filteredSections.map((section, index, filteredArray) => {
                      const IconComponent =
                        MuiIcons[section.icon] || MuiIcons.HelpOutline;
                      return (
                        <Paper
                          key={section.id}
                          elevation={0}
                          onClick={() => handleChangeTab(null, index + 1)}
                          sx={{
                            p: 3,
                            pt: 3,
                            pb: 3,
                            minWidth: { xs: "110px", md: "auto" },
                            flexGrow: filteredArray.length <= 8 ? 1 : 0,
                            flexShrink: 0,

                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            cursor: "pointer",
                            borderTopLeftRadius: index === 0 ? 16 : undefined,
                            borderBottomLeftRadius:
                              index === 0 ? 16 : undefined,
                            borderTopRightRadius:
                              index === filteredArray.length - 1
                                ? 16
                                : undefined,
                            borderBottomRightRadius:
                              index === filteredArray.length - 1
                                ? 16
                                : undefined,
                            backgroundColor:
                              currentTab === index + 1
                                ? `${section.color}10`
                                : theme.palette.mode === "dark"
                                  ? "#1d2e3d"
                                  : "#fff",
                            transition: "all 0.2s ease",
                            backgroundImage: "none",
                            position: "relative", // For positioning the arrow
                            "&:hover": {
                              transform: "scale(1.05)",
                              borderColor: "transparent",
                            },
                            "&:hover .icon": {
                              transform: "scale(1.1) rotate(7deg)",
                              transition: "transform 0.3s ease",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: 50,
                              height: 50,
                              borderRadius: 70,
                              bgcolor: `${section.color}10`,
                            }}
                          >
                            <IconComponent
                              className="icon"
                              sx={{
                                color: section.color,
                                fontSize: 29,
                                transition: "transform 0.3s ease",
                              }}
                            />
                          </Box>
                          <Box
                            className="text"
                            sx={{
                              fontWeight: currentTab === index + 1 ? 700 : 500,
                              fontSize:
                                role === "teacher" ? "0.95rem" : "0.95rem",
                              textAlign: "center",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            {section.title}
                          </Box>

                          {/* Arrow indicator at bottom */}
                          {currentTab === index + 1 && (
                            <Box
                              sx={{
                                position: "absolute",
                                bottom: -10,
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: 0,
                                height: 0,
                                borderLeft: "10px solid transparent",
                                borderRight: "10px solid transparent",
                                borderTop: `10px solid ${section.color}`,
                              }}
                            />
                          )}
                        </Paper>
                      );
                    })}
                  </Box>
                </Box>
              </>
            )}

            {renderFunctionContent()}
          </Box>
        </Box>
      </Drawer>
      <FeedbackDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        user={user}
        contactForm="true"
      />
    </>
  );
};

export default HelpDialog;
